// This file is automatically compiled by Vite, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import '~/styles/application.css';
import '~/styles/animate.compat.css';

import '@quasar/extras/eva-icons/eva-icons.css';
import '@quasar/extras/fontawesome-v6/fontawesome-v6.css';
import '@quasar/extras/line-awesome/line-awesome.css';
import '@quasar/extras/material-icons-outlined/material-icons-outlined.css';
import '@quasar/extras/material-icons/material-icons.css';
import '@quasar/extras/material-symbols-outlined/material-symbols-outlined.css';
import '@quasar/extras/mdi-v5/mdi-v5.css';

import { createApp, h } from 'vue';

import { Quasar } from 'quasar';
import { Dialog } from 'quasar'; // Dialogs used globally for basic use cases, like the native JS alert(), prompt(), etc.
import { Notify } from 'quasar'; // Display animated messages (floating above everything in your pages).
import { LocalStorage } from 'quasar';
import { useQuasar } from "quasar";

import { router, createInertiaApp } from '@inertiajs/vue3';

import { intercom } from './intercom';

import Plausible from 'plausible-tracker';
const plausibleUrl = document.querySelector(
  'meta[name="plausible-url"]',
).content;
if (plausibleUrl) {
  const plausible = Plausible({
    domain: document.querySelector('meta[name="app-host"]').content,
    apiHost: plausibleUrl,
  });

  router.on('navigate', () => {
    plausible.trackPageview();
  });
}

// Google Analytics / GTM: only loaded once the user has accepted analytics
// cookies. Otherwise the consent banner (CookieConsent) takes over.
import { getConsent, initAnalytics, queueSignupEvent } from '~/analytics';
import CookieConsent from '~/shared/cookie_consent.vue';

queueSignupEvent();
if (getConsent() === 'accepted') {
  initAnalytics();
}

import { rails } from './rails';

const pages = import.meta.glob('../pages/**/*.vue', { eager: true });

createInertiaApp({
  resolve: (name) => {
    const component = pages[`../pages/${name}.vue`];
    if (!component)
      throw new Error(
        `Unknown page ${name}. Is it located under 'pages/' with a .vue extension?`,
      );

    return component;
  },

  title: (title) => (title ? `${title} - ComptaCrypto` : 'ComptaCrypto'),
  progress: false, // NProgress Ajax Bar

  setup({ el, App, props, plugin }) {
    const vueApp = createApp({
      // CookieConsent is rendered next to the page so the banner shows on
      // every page of the app.
      render: () => [h(App, props), h(CookieConsent)],
    });
    
    vueApp.config.globalProperties.$intercom = intercom;
    vueApp.config.globalProperties.$q = useQuasar;
    vueApp.config.globalProperties.$rails = rails;
    vueApp.use(
      Quasar,
      {
        plugins: {
          Dialog, // $q.dialog()
          Notify, // $q.notify()
          LocalStorage, // $q.localStorage()
        },
        config: {
          notify: {
            position: 'bottom-left',
          },
        },
      },
    );
    vueApp.use(plugin).mount(el);
  },
});
